import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/logo.svg'


const _hoisted_1 = {
  key: 0,
  class: "mb-4 flex justify-center"
}
const _hoisted_2 = {
  "data-cy": "profileData",
  class: "rounded-md bg-greyLight p-5 text-sm leading-7 text-grey"
}
const _hoisted_3 = { class: "text-gray-500" }
const _hoisted_4 = { class: "text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_trusted_devices = _resolveComponent("trusted-devices")!
  const _component_ProfilePageSkeleton = _resolveComponent("ProfilePageSkeleton")!
  const _component_StandartTemplate = _resolveComponent("StandartTemplate")!

  return (_openBlock(), _createBlock(_component_StandartTemplate, null, {
    default: _withCtx(() => [
      (!_ctx.isBrand.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "logo"
            }, null, -1)
          ]))]))
        : _createCommentVNode("", true),
      (_ctx.userData)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _cache[1] || (_cache[1] = _createTextVNode(" ФИО: ", -1)),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.userData.full_name), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[2] || (_cache[2] = _createTextVNode(" Номер телефона: ", -1)),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.userData.phone_number), 1)
              ])
            ]),
            _createVNode(_component_trusted_devices, { class: "mt-5" })
          ], 64))
        : (_openBlock(), _createBlock(_component_ProfilePageSkeleton, { key: 2 }))
    ]),
    _: 1
  }))
}